var exports = {
  "kL": "xfd349460--db0b0c--container",
  "nM": "xfd349460--db0b0c--row",
  "RI": "xfd349460--db0b0c--room-type",
  "q9": "xfd349460--db0b0c--price",
  "z8": "xfd349460--db0b0c--props-count",
  "UE": "xfd349460--db0b0c--arrow",
};

module.exports = exports;
